export function formatarData(dataISO: string) {
  const data = new Date(dataISO);
  // Ajusta para fuso horário -3h (São Paulo)
  data.setTime(data.getTime() - 3 * 60 * 60 * 1000);

  const dia = String(data.getUTCDate()).padStart(2, "0");
  const mes = String(data.getUTCMonth() + 1).padStart(2, "0");
  const ano = String(data.getUTCFullYear()).slice(-2);
  let horas = data.getUTCHours();
  const minutos = String(data.getUTCMinutes()).padStart(2, "0");

  const periodo = horas >= 12 ? "PM" : "AM";
  horas = horas % 12 || 12;

  return `${dia}/${mes}/${ano} - ${horas}:${minutos} ${periodo}`;
}

export function formatKey(key: string): string {
  // Se for sigla (todas maiúsculas) retorna sem espaço
  if (/^[A-Z]+$/.test(key)) return key;

  return key
    .replace(/([A-Z])/g, " $1")
    .replace(/^./, (str) => str.toUpperCase());
}

export const formatBodyText = (text: string) => {
  return text
    .replace(/\n/g, "<br />")
    .replace(/(\*\*)(.*?)\1/g, "<strong>$2</strong>")
    .replace(/(__)(.*?)\1/g, "<u>$2</u>");
};

const functionDate = { formatarData, formatKey, formatBodyText };
export default functionDate;
